// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"342881bb","341":"8d862b40","463":"0e100176","756":"f37fc4c8","899":"c694cae1","955":"0abe1eee"}[chunkId] + ".chunk.css";
};